import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from './../model/users.model';
import { Corrective_Action, NonCompliance,CarAuthoirzedUsers } from '../model/non-compliance.model';


@Injectable({
  providedIn: 'root'
})
export class NonComplianceService {
  @LocalStorage() url: Url;
  private headers = new Headers({ 'Content-Type': 'application/json' });
  // Http Headers
  httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
  }

  constructor(public http:HttpClient) { }

  getFuelMiscData(): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getFuelMiscData', this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }
  
  getNCRList(): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getNCR', this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  createNCR(ncr:NonCompliance): Observable<NonCompliance> {	
    return this.http.post<NonCompliance>(this.url.rest  + '/tms/createNCR', ncr , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateNCR(ncr:NonCompliance): Observable<NonCompliance> {
    return this.http.post<NonCompliance>(this.url.rest  + '/tms/updateNCR', ncr, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  
  deleteNCR(id: number) {
    return this.http.delete(this.url.rest  + '/tms/deleteNCR/' + id);
  }   

  getCARList(): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getCAR', this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  createCAR(car:Corrective_Action): Observable<Corrective_Action> {	
    return this.http.post<Corrective_Action>(this.url.rest  + '/tms/createCAR', car , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateCAR(car:Corrective_Action): Observable<Corrective_Action> {
    return this.http.post<Corrective_Action>(this.url.rest  + '/tms/updateCAR', car, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }


  cancelCar(id: number) {
    return this.http.delete(this.url.rest  + '/tms/cancelCAR/' + id);
  }   



      // Error handling
      handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }


    getCARAuthorizedUsers(): Observable<any> { 
      return this.http.get<any>( this.url.rest + '/tms/getCARAuthorizedUsers', this.httpOptions )
          .pipe(
              retry(1),
              catchError(this.handleError)
          )   
    }

    addCARAuthorizedUser(car_approvedby:CarAuthoirzedUsers): Observable<CarAuthoirzedUsers> {
      return this.http.post<CarAuthoirzedUsers>(this.url.rest  + '/tms/addCARAuthorizedUser', car_approvedby, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    deleteCARAuthorizedUser(id: number) {
      return this.http.delete(this.url.rest + '/tms/truncateCarAuthorizedUser/' + id);
  }

}
